<template>
  <div class="flex flex-col h-full w-full overflow-y-auto">
    <el-skeleton
      :rows="row"
      animated
      class="flex flex-col h-full overflow-y-auto"
    >
      <template #template>
        <el-table
          :data="skeletonData"
          style="width: 100%"
          border
          class="w-full funnels-table overflow-y-auto"
          :size="sizeTable"
          animated
          height="100%"
        >
          <el-table-column width="50" class="flex items-center justify-center">
            <template>
              <el-skeleton-item
                variant="text"
                style="width: 20px; height: 20px"
              ></el-skeleton-item>
            </template>
          </el-table-column>

          <el-table-column
            v-for="(col, index) in row"
            :key="index"
            :width="250"
          >
            <template #default>
              <el-skeleton-item
                variant="text"
                class="ml-2 mb-1 h-2.5"
                style="width: 180px"
              />
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-skeleton>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "SkeletonTable",
  props: {
    column: {
      type: Number,
      default: 15,
    },
    row: {
      type: Number,
      default: 6,
    },
    sizeTable: {
      type: String,
      default: "large",
    },
  },
  data() {
    return {
      skeletonData: ref(Array.from({ length: this.column }, () => ({}))),
    };
  },
};
</script>
